import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/styling';
import MenuIcon from '@/shared/assets/header/menu.svg?react';
import CloseIcon from '@/shared/assets/close-icon.svg?react';

type Props = {
  isMenuOpen: boolean;
  onClick: () => void;
  className?: string;
};

const AuthorizedLayoutMenuButton = ({
  onClick,
  isMenuOpen,
  className,
}: Props) => {
  return (
    <Button
      variant="outline"
      size="icon"
      className={cn(
        'border border-stroke-bg rounded-[1rem] h-[3.2rem] w-[3.2rem] shadow-none bg-background',
        className
      )}
      onClick={onClick}>
      {isMenuOpen ? (
        <CloseIcon className="size-[1.6rem] text-primary" />
      ) : (
        <MenuIcon className="size-[1.6rem] text-primary" />
      )}
    </Button>
  );
};

export { AuthorizedLayoutMenuButton };
